export enum DeviceSoftwareStatus {
  OK = 'OK',
  WARNING = 'WARNING',
  UPDATE_REQUESTED = 'UPDATE_REQUESTED',
  IMAGER_FIRMWARE_UPDATE_REQUIRED = 'IMAGER_FIRMWARE_UPDATE_REQUIRED',
  CUSTOM_FIRMWARE = 'CUSTOM_FIRMWARE',
  MISSING_DATA = 'MISSING_DATA',
}
